import { ArrowRight, TrendingUp, Bitcoin, Activity, Coins } from "lucide-react";

const MARKETS = [
  {
    title: "Synthetic Indices",
    desc: "24/7 markets generated from algorithms — Volatility 10/25/50/75/100, Crash & Boom, Step Indices.",
    icon: Activity,
    stat: "24/7",
    statLabel: "Always open",
    badge: "Deriv's specialty",
    href: "#how",
  },
  {
    title: "Forex",
    desc: "50+ major, minor and exotic currency pairs with tight spreads and high leverage.",
    icon: TrendingUp,
    stat: "50+",
    statLabel: "Currency pairs",
    href: "#platforms",
  },
  {
    title: "Cryptocurrencies",
    desc: "Trade BTC, ETH, XRP and more — both spot and CFD style contracts.",
    icon: Bitcoin,
    stat: "20+",
    statLabel: "Crypto assets",
    href: "#platforms",
  },
  {
    title: "Commodities",
    desc: "Gold, silver, oil and other metals — trade global commodity volatility from one account.",
    icon: Coins,
    stat: "10+",
    statLabel: "Instruments",
    href: "#platforms",
  },
];

const Markets = () => {
  return (
    <section
      id="markets"
      data-testid="markets-section"
      className="relative py-24 lg:py-32 vts-noise"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="text-xs uppercase tracking-[0.25em] text-vts-blue font-semibold mb-4">
            01 — Markets
          </div>
          <h2 className="font-heading font-bold text-4xl sm:text-5xl text-white tracking-tighter">
            Four asset classes.<br />
            <span className="text-vts-silver">One trading desk.</span>
          </h2>
          <p className="mt-5 text-vts-silver/70 text-base font-body leading-relaxed">
            From Deriv's exclusive Volatility Indices that never sleep, to global Forex,
            Crypto and Commodities — access the entire Deriv catalog through VTS.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 auto-rows-fr">
          {MARKETS.map((m, idx) => {
            const Icon = m.icon;
            const isBig = idx === 0;
            return (
              <a
                key={m.title}
                href={m.href}
                data-testid={`market-card-${m.title.toLowerCase().replace(/\s+/g, "-")}`}
                className={`group relative vts-card vts-card-hover p-7 lg:p-8 ${
                  isBig ? "lg:col-span-6 lg:row-span-2" : "lg:col-span-3"
                }`}
              >
                {m.badge && (
                  <span className="absolute top-5 right-5 text-[10px] uppercase tracking-wider text-vts-blue font-semibold border border-vts-blue/30 bg-vts-blue/10 px-2 py-1 rounded">
                    {m.badge}
                  </span>
                )}
                <div className="flex items-center justify-between mb-6">
                  <div className="h-10 w-10 rounded-md bg-vts-blue/15 border border-vts-blue/30 flex items-center justify-center group-hover:bg-vts-blue/25 transition">
                    <Icon className="h-5 w-5 text-vts-blue" />
                  </div>
                </div>
                <h3 className="font-heading font-semibold text-xl lg:text-2xl text-white mb-3 tracking-tight">
                  {m.title}
                </h3>
                <p className="text-vts-silver/70 text-sm font-body leading-relaxed mb-6">
                  {m.desc}
                </p>
                <div className="flex items-end justify-between border-t border-vts-line pt-4">
                  <div>
                    <div className="font-mono text-2xl font-semibold text-white tabular-nums">
                      {m.stat}
                    </div>
                    <div className="text-[10px] uppercase tracking-wider text-vts-silver/60 mt-0.5">
                      {m.statLabel}
                    </div>
                  </div>
                  <ArrowRight className="h-4 w-4 text-vts-silver/40 group-hover:text-vts-blue group-hover:translate-x-1 transition" />
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Markets;
